export default "__VITE_ASSET__a8bf8770__"